import Vue from 'vue'

/**
 * Safe check value for UI display
 * Undefined, null and empty values will instead return a placeholder
 * @name Safe Check Value
 * @returns {string, number} Input data to be checked
 */

const defaultOptions = {
  placeholder: '-',
  trimStrings: true,
}

const safeCheckValue = (inputVal, customOptions = {}) => {
  let content = inputVal
  const options = Object.assign({}, defaultOptions, customOptions)

  if (typeof inputVal === 'string' && options.trimStrings) {
    content = inputVal.trim()
  }

  return !content && content !== false ? options.placeholder : content
}

Vue.filter('safeCheckValue', safeCheckValue)

export default safeCheckValue
